import { PIXI } from '@colonist/pixi';
import { GameColor } from '@colonist/ui-game';
import { GameFont } from '../GameFont.ts';
import { uiGameManager } from '../../../shared/scripts/EntryShared.ts';
import { clientI18n } from '../ClientI18n.ts';
import { UIGameResponsiveController } from '../ui_game/UIGameResponsiveController.ts';
export class TextView extends PIXI.Text {
    /**
     * @deprecated Use {@link setText} instead
     */ set text(text) {
        super.text = text;
    }
    /**
     * @deprecated Use {@link changeStyle} instead
     */ set style(style) {
        super.style = style;
    }
    setText(text, cache = true) {
        const translatedText = clientI18n.t(text.key, text.options);
        if (super.text == translatedText) return;
        this.resetCache(()=>super.text = translatedText, cache);
    }
    getText() {
        return super.text;
    }
    hide() {
        if (this.parent == undefined) return;
        this.parent.removeChild(this);
    }
    changeStyle(newStyle, cache = true) {
        this.resetCache(()=>super.style = {
                ...super.style,
                ...newStyle
            }, cache);
    }
    repositionY(centerY) {
        if (centerY) {
            this.y = this.initialY + (this.initialH - this.height) / 2;
        } else {
            this.y = this.initialY;
        }
    }
    centerX() {
        this.x = this.initialX + (this.initialW - this.width) / 2;
    }
    disableTip() {
        uiGameManager.toolTipController.disableTip(this);
    }
    setTip(title, bodyParagraphs) {
        const toolTipText = ()=>({
                title: title,
                body: bodyParagraphs
            });
        uiGameManager.toolTipController.createTip(toolTipText, this);
    }
    initClick() {
        this.on('click', (event)=>{
            this.clickAction(event);
        });
        this.on('tap', (event)=>{
            this.clickAction(event);
        });
    }
    setClickAction(action) {
        this.interactive = true;
        this.cursor = 'pointer';
        this.clickAction = action;
    }
    removeClickAction() {
        this.interactive = false;
        this.cursor = 'auto';
    }
    centerXInParent() {
        if (this.parent == undefined) return;
        this.x = this.parent.width / 2 - this.width / 2;
    }
    centerYInParent() {
        if (this.parent == undefined) return;
        this.y = this.parent.height / 2 - this.height / 2;
    }
    makeBold(cache = true) {
        this.changeStyle({
            fontWeight: GameFont.Weight.Bold
        }, cache);
    }
    makeSemiBold(cache = true) {
        this.changeStyle({
            fontWeight: GameFont.Weight.SemiBold
        }, cache);
    }
    removeBold(cache = true) {
        this.changeStyle({
            fontWeight: GameFont.Weight.Normal
        }, cache);
    }
    resetCache(callback, cache = true) {
        if (cache == false) {
            callback();
            return;
        }
        this.cacheAsBitmap = false;
        callback();
        this.cacheAsBitmap = true;
    }
    constructor(text, x, y, w, h, container, fontSize = GameFont.Size.Normal, color = GameColor.getColor(GameColor.Color.Gray0), centerY = true, style, cache = true){
        const baseStyles = {
            fontFamily: 'Open Sans',
            fontSize: GameFont.getResponsiveSize(fontSize),
            fill: color,
            wordWrap: true,
            wordWrapWidth: w,
            align: 'center',
            breakWords: true
        };
        super(clientI18n.t(text.key, text.options), {
            ...baseStyles,
            ...style
        });
        this.resolution = 2 * UIGameResponsiveController.resolutionScale;
        this.roundPixels = true;
        this.initialX = x;
        this.initialY = y;
        this.initialW = w;
        this.initialH = h;
        this.x = x;
        this.repositionY(centerY);
        this.clickAction = (event)=>undefined;
        this.initClick();
        if (cache) this.cacheAsBitmap = true;
        container.addChild(this);
    }
}
